import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Icons } from '../../../../component/icons/Icons';
import { useIdentityCheckCustomers } from './hooks/useIdentityCheckCustomers';
import { CustomerIdentityPanel } from './CustomerIdentityPanel';

interface Props {
  open: boolean;
  onClose: () => void;
  dealId: number;
  mainCustomerId: number;
}

export function IdentityCheckDialog({ open, onClose, dealId, mainCustomerId }: Props) {
  const { t } = useTranslation();
  const { customers, loading } = useIdentityCheckCustomers(dealId, mainCustomerId, open);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      sx={{ '.MuiDialogTitle-root': { pt: 0 } }}
    >
      <Box sx={{ textAlign: 'right' }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{ p: 0, height: '32px', width: '32px', minWidth: 'unset' }}
          aria-label="close"
        >
          {Icons.clear()}
        </Button>
      </Box>

      <DialogTitle>
        <Typography variant="h6">{t('identityCheck.dialogTitle')}</Typography>
      </DialogTitle>

      <DialogContent dividers>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {customers.map((customer) => (
              <CustomerIdentityPanel
                key={customer.customerId}
                customer={customer}
                dealId={dealId}
              />
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
